/**
 * mapModulesString
 * @param {*} modulesString Is a comma separated string of modules
 * @returns Array of uppercased module strings
 */
export const mapModulesString = (modulesString) => {
  if (!modulesString) return modulesString;
  return modulesString
    .split(',')
    ?.map((m) => {
      const module = m?.trim();
      if (module === '-') return undefined;
      return (module).toUpperCase();
    })
    ?.filter((m) => m);
};
